require('../website_newgen/js/react/initializer.js')



// WEBPACK FOOTER //
// ./app/javascript/packs/site_newgen.js